// import IMG from "../../assets/plaeholder.jpg";
import "./portfolio.css";

import IMG1 from "../../assets/extraado.jpg";
import IMG10 from "../../assets/feimage.jpeg";
import IMG11 from "../../assets/j3water.jpeg";
import IMG12 from "../../assets/cv.png";
import IMG13 from "../../assets/kj.png";
import IMG2 from "../../assets/gonda.jpg";
import IMG3 from "../../assets/derzam1.jpg";
import IMG4 from "../../assets/genie.jpg";
import IMG5 from "../../assets/derzam_web.PNG";
import IMG6 from "../../assets/ecommerce.JPG";
import IMG7 from "../../assets/healner_web.PNG";
// import IMG8 from "../../assets/pms_react.jpeg";
import IMG9 from "../../assets/inmayinc.jpg";
import React from "react";
// import beleeve from "../../assets/beleeve.jpeg";
import enfoque from "../../assets/enfoque.jpeg";
import gpt from "../../assets/gpt.jpeg";
import keyhole from "../../assets/keyhole.png";
import millennium from "../../assets/millennium.jpeg";
import prm from "../../assets/prm.jpeg";
import xvision from "../../assets/xvision.jpeg";

const Portfolio = () => {
  const soloProjects = [
    {
      id: 192,
      title: "Enfoque React Native",
      img: enfoque,
      live: "https://enfoque.gob.do/",
      // link: "https://drive.google.com/drive/folders/1HtR2P0Sv3-4uKowQtp-_0nWwkl1kvoV3?usp=sharing",
      // github: 'https://github.com/Meri-MG/bookstore---react',
    },
    {
      id: 193,
      title: "Keyhole Social media analytics Next JS",
      img: keyhole,
      live: "https://keyhole.co/",
      // link: "https://drive.google.com/drive/folders/1HtR2P0Sv3-4uKowQtp-_0nWwkl1kvoV3?usp=sharing",
      // github: 'https://github.com/Meri-MG/bookstore---react',
    },
    {
      id: 100,
      title: "CureVision GmBH React Native",
      img: IMG12,
      live: "https://www.curevision.de/",
      // link: "https://drive.google.com/drive/folders/1HtR2P0Sv3-4uKowQtp-_0nWwkl1kvoV3?usp=sharing",
      // github: 'https://github.com/Meri-MG/bookstore---react',
    },
    {
      id: 197,
      title: "Millennium Pharmacy React Native",
      img: millennium,
      live: "https://www.curevision.de/",
      // link: "https://drive.google.com/drive/folders/1HtR2P0Sv3-4uKowQtp-_0nWwkl1kvoV3?usp=sharing",
      // github: 'https://github.com/Meri-MG/bookstore---react',
    },
    {
      id: 190,
      title: "PRM Innova React Native",
      img: prm,
      live: "https://www.curevision.de/",
      // link: "https://drive.google.com/drive/folders/1HtR2P0Sv3-4uKowQtp-_0nWwkl1kvoV3?usp=sharing",
      // github: 'https://github.com/Meri-MG/bookstore---react',
    },
    {
      id: 10,
      title: "FairlyEven React Native",
      img: IMG10,
      link: "https://drive.google.com/drive/folders/1dC9u3NlzNhb6MQGfunHmo7hbQ4yLaOkZ?usp=sharing",
      play: "https://play.google.com/store/apps/details?id=com.fairlyeven",
      apple: "https://apps.apple.com/app/fairly-even/id1645714393",
      // github: 'https://github.com/lukinoo/math-resource',
    },
    {
      id: 9,
      title: "Inmay inc Driver Side React Native",
      img: IMG9,
      link: "https://drive.google.com/drive/folders/15nHThwlu-BPAis17IfF_UVV-X483Wwgw?usp=sharing",
      play: "https://play.google.com/store/apps/details?id=com.inmay",
      apple: "https://apps.apple.com/pk/app/inmay-driver/id6444869333",
      // github: 'https://github.com/lukinoo/math-resource',
    },
    {
      id: 199,
      title: "X-Vison React Native",
      img: xvision,
      live: "https://www.curevision.de/",
      // link: "https://drive.google.com/drive/folders/1HtR2P0Sv3-4uKowQtp-_0nWwkl1kvoV3?usp=sharing",
      // github: 'https://github.com/Meri-MG/bookstore---react',
    },

    {
      id: 129,
      title: "Chat-GPT React Native",
      img: gpt,
      // live: "https://www.curevision.de/",
      // link: "https://drive.google.com/drive/folders/1HtR2P0Sv3-4uKowQtp-_0nWwkl1kvoV3?usp=sharing",
      github: "https://github.com/Yousafzubair991/React-Native-ChatGPT-App",
    },
    {
      id: 2,
      title: "Go NDA React Native",
      img: IMG2,
      link: "https://drive.google.com/drive/folders/1ebFP_85EEUD7ndJ6ZRoKdH99XSdVlr7u?usp=sharing",
      play: "https://play.google.com/store/apps/details?id=com.gonda&hl=en&gl=US",
      // github: 'https://github.com/Meri-MG/metrics-webapp---react',
    },
    {
      id: 20,
      title: "KonJae React Native",
      img: IMG13,
      link: "https://drive.google.com/drive/folders/1wRaAZ95mFnjHLGXxqUVeWtRgvRheRB8U?usp=sharing",
      play: "https://play.google.com/store/apps/details?id=com.konjae1",
      // github: 'https://github.com/Meri-MG/metrics-webapp---react',
    },
    {
      id: 3,
      title: "Derzam React Native",
      img: IMG3,
      link: "https://drive.google.com/drive/folders/1iv1MFZl3qaOT6m0Vti91ygfOjafncr6K?usp=sharing",
      // github: 'https://github.com/Meri-MG/To-Do-List',
      play: "https://play.google.com/store/apps/details?id=com.derzam",
    },
    {
      id: 4,
      title: "Bid Genie React Native Expo",
      img: IMG4,
      link: "https://drive.google.com/drive/folders/1cF_WfGCSfXxEIBGOhA9zcF4pg5SuklgG?usp=sharing",
      // github: 'https://github.com/Meri-MG/shelter',
    },
    {
      id: 1,
      title: "Extraado React Native",
      img: IMG1,
      link: "https://drive.google.com/drive/folders/1HtR2P0Sv3-4uKowQtp-_0nWwkl1kvoV3?usp=sharing",
      // github: 'https://github.com/Meri-MG/bookstore---react',
      play: "https://play.google.com/store/apps/details?id=com.extraado.extraadoV2",
      apple: "https://apps.apple.com/gb/app/extraado/id6450844050",
    },
    {
      id: 11,
      title: "J3 Water Delivery React Native",
      img: IMG11,
      link: "https://drive.google.com/drive/folders/1cm7eskoMXmOvkQ7AQwUYBw2xgJQjdQ9F?usp=sharing",
      // github: 'https://github.com/lukinoo/math-resource',
    },
    {
      id: 5,
      title: "Derzam Website Next JS",
      img: IMG5,
      // link: 'https://meri-mg.github.io/Unilab-world-news/',
      // github: 'https://github.com/Meri-MG/Unilab-world-news',
      live: "https://derzam.com/",
    },
    {
      id: 6,
      title: "E-commerce React JS",
      img: IMG6,
      link: "https://drive.google.com/drive/folders/1Qmw6PLT5uckBBHTGv2NrWArXfmcJChLx?usp=sharing",
      // github: 'https://github.com/lukinoo/math-resource',
    },
    {
      id: 7,
      title: "Healnet Website React JS",
      img: IMG7,
      link: "https://drive.google.com/drive/folders/1AFwRRQflPWe-eC4sb_C41labM1QcOPX6?usp=sharing",
      // github: 'https://github.com/Meri-MG/shelter',
    },
    // {
    //   id: 8,
    //   title: "Product Management System",
    //   img: IMG8,
    //   link: "https://drive.google.com/drive/folders/1iShjwgFr4Ugrss2GryZwcyyo2Mph2Niw?usp=sharing",
    //   // github: 'https://github.com/Meri-MG/Unilab-world-news',
    // },
  ];

  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {soloProjects.map((pro) => (
          <article className="portfolio__item" key={pro.id}>
            <div className="portfolio__item-image">
              <img src={pro.img} alt={pro.title} />
            </div>
            <h3>{pro.title}</h3>
            <div className="portfolio__item-cta">
              {pro.github && (
                <a href={pro.github} className="btn">
                  GitHub
                </a>
              )}
              {pro.link && (
                <a href={pro.link} className="btn btn-primary">
                  Demo
                </a>
              )}
              {pro.play && (
                <a href={pro.play} className="btn">
                  Play store
                </a>
              )}
              {pro.live && (
                <a href={pro.live} className="btn btn btn-primary">
                  Available
                </a>
              )}
              {pro.apple && (
                <a href={pro.apple} className="btn btn btn-primary">
                  Apple Store
                </a>
              )}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
